import { render, staticRenderFns } from "./wine-investor.vue?vue&type=template&id=0a3a89fe&scoped=true"
import script from "./wine-investor.vue?vue&type=script&lang=js"
export * from "./wine-investor.vue?vue&type=script&lang=js"
import style0 from "./wine-investor.vue?vue&type=style&index=0&id=0a3a89fe&prod&scoped=true&lang=css"
import style1 from "./wine-investor.vue?vue&type=style&index=1&id=0a3a89fe&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a89fe",
  null
  
)

export default component.exports